import React from "react";

const PaymentGateway = () => {
  return <div>PaymentGateway</div>;
};

export default PaymentGateway;
